import React from 'react';
import { 
  HelpCircle, 
  Calendar, 
  CreditCard, 
  Plane, 
  Home, 
  ShoppingBag, 
  Shield, 
  Map,
  SunSnow
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Calendar,
      title: 'Выбор даты',
      description: 'Май и сентябрь — лучшее время для посещения большинства городов России. Мягкая погода и меньше туристов.'
    },
    {
      icon: SunSnow,
      title: 'Сезонность',
      description: 'Учитывайте сезонность. Низкий сезон предложит экономию до 30% на жилье, но может быть меньше активностей.'
    },
    {
      icon: Home,
      title: 'Жилье',
      description: 'Апартаменты часто выгоднее отелей при длительных поездках или путешествиях с семьей из-за возможности готовить.'
    },
    {
      icon: Plane,
      title: 'Транспорт',
      description: 'Бронируйте билеты заранее. Оптимальное время — за 45-60 дней для поездов и самолетов.'
    },
    {
      icon: ShoppingBag,
      title: 'Планирование',
      description: 'Закладывайте 10-15% бюджета на непредвиденные расходы и сувениры.'
    },
    {
      icon: Shield,
      title: 'Страховка',
      description: 'Не экономьте на страховке. При поездках в отдаленные регионы выбирайте расширенную защиту.'
    },
    {
      icon: Map,
      title: 'Локации',
      description: 'Популярные города России обычно дороже. Рассмотрите близлежащие небольшие города для экономии.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-purple-500" />
        Советы путешественникам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <CreditCard className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-purple-700 dark:text-purple-300 mb-2">
              Бюджетные поездки по России
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400 mb-3">
              Рассмотрите путешествия в Казань, Нижний Новгород или Калининград. Эти города предлагают богатую культурную программу и более доступные цены.
            </p>
            <a 
              href="#" 
              className="w-full block py-1.5 text-xs bg-purple-500 text-white rounded hover:bg-purple-600 transition-colors text-center"
            >
              Лучшие направления
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;